import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPDimensionsAndDetailsUI from './PDPDimensionsAndDetailsUI';
const PDPDimensionsAndDetailsInner = () => {
  const $ = _c(4);
  const {
    loading,
    error,
    data: t0
  } = useProductAttributes();
  const {
    dimensions
  } = t0;
  if (error) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="PDPDimensionsAndDetails__filler-error" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== dimensions?.length || $[2] !== loading) {
    t1 = dimensions?.length ? <PDPDimensionsAndDetailsUI loading={loading} /> : <div className="PDPDimensionsAndDetails__filler-loading" />;
    $[1] = dimensions?.length;
    $[2] = loading;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
const PDPDimensionsAndDetails = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPDimensionsAndDetailsInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPDimensionsAndDetails;